export const labels = {
	message: {
		label: "Label.MobileCreator.Import.ProcessingFiles",
		default: "{0} of {1} photos processed ...",
		// description: Progress message shown after photos have been selected by the user and they are being processed before they can be used in the product."
		// 0: amount of photos that have finished preprocessing
		// 1: total amount of photos that need preprocessing
	},
};
